import { useContext } from "react";
import WsContext from "../context/WsContext";

export default function useEventEmitter() {
  return useContext(WsContext).eventEmitter;
}
